// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TourBreadcrumb_wrapper__lwG9p","breadcrumbs":"TourBreadcrumb_breadcrumbs__qSpan"};